import { FullWidthBox } from '@app/components/base/FullWidthBox';
import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { ReactNode } from 'react';

export interface VideoEditionsCategoryToolbarProps {
  children?: ReactNode;
}

/**
 * Full-bleed PageToolbar for video-editions chip navigation when rendered inside Page.Content.
 * Cancels horizontal page padding and pulls up under the page header so the strip reads like
 * top-level toolbars (e.g. Audit templates).
 */
export function VideoEditionsCategoryToolbar({ children }: VideoEditionsCategoryToolbarProps) {
  return (
    <FullWidthBox sx={{ mt: -3 }}>
      <PageToolbar>{children}</PageToolbar>
    </FullWidthBox>
  );
}
